import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		cardActions: {
			paddingLeft: 0,
			paddingTop: 24,
		},
		note: {
			fontSize: 12,
		},
		radio: {
			color: "#616161",
			// Was JSS `&$radioChecked` (our `checked`-slot override class). tss-react cannot infer the
			// nested-selector class map through the withMediaQuery wrapper, so target MUI's global checked
			// class — the Radio root carries `.Mui-checked` when selected, matching the original behavior
			// (consistent with the infra scope-2 `&$checked` -> `&.Mui-checked` migration).
			"&.Mui-checked": {
				color: "#616161",
			},
		},
		radioChecked: {},
		radioLabel: {
			fontSize: 12,
			fontWeight: "bold",
			paddingLeft: 12,
		},
		textFieldContainer: {
			paddingRight: 12,
		},
		// --- Refreshed page (MAX-3629) ---
		headerRow: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			justifyContent: "space-between",
			[theme.breakpoints.down("xs")]: {
				flexDirection: "column",
				alignItems: "flex-start",
				gap: 8,
				"& .MuiButton-root": {
					marginLeft: -5,
				},
			},
		},
		introText: {
			// Primary text color per design (MAX-3918: #1C1B1F).
			color: theme.palette.custom.textPrimary,
			marginBottom: 8,
		},
		sectionHeading: {
			fontWeight: "bold",
			fontSize: 18,
			color: theme.palette.custom.textPrimary,
			marginBottom: 8,
		},
		sectionDescription: {
			// Primary text color per design (MAX-3918: #1C1B1F). The Bankrate link keeps its own color.
			color: theme.palette.custom.textPrimary,
			marginBottom: 24,
		},
		fieldGroup: {
			maxWidth: 340,
			marginBottom: 24,
		},
		toggleRow: {
			marginTop: -12,
			marginBottom: 24,
		},
		warningIcon: {
			color: theme.palette.warning.main,
			marginRight: 8,
			flexShrink: 0,
		},
	} satisfies Record<string, CSSObject>;
};
